import * as React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import classes from './AccountLayout.module.css';

const accountLinks = [
  { to: '/website/account/calendar', label: 'Calendar' },
  { to: '/website/account/profile', label: 'Profile' },
  { to: '/website/account/portfolio', label: 'Portfolio' },
  { to: '/website/account/cancelled-bookings', label: 'Cancelled' },
];

export const WebsiteAccountLayout = (): React.JSX.Element => {
  const location = useLocation();

  return (
    <>
      <Nav variant="underline" className={classes.AccountLayoutNav}>
        {accountLinks.map((item) => (
          <Nav.Item key={item.to}>
            <Nav.Link as={Link} to={item.to} active={location.pathname === item.to}>
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Outlet />
    </>
  );
};
